/* eslint-disable react/jsx-indent, indent */
import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import ToggleSwitch from '@trendmicro/react-toggle-switch';

const noCCOptions = [
  {
    label: 'Cancel appointment within 24 hours of making the booking',
    value: 'CANCEL24',
  },
  {
    label: 'Cancel appointment within 1 hour of making the booking',
    value: 'CANCEL1',
  },
  {
    label: 'Let me know 1 hour after making the booking',
    value: 'FORWARD1',
  },
  {
    label: 'Let me know 24 hours after making the booking',
    value: 'FORWARD24',
  },
];

const collectCCOptions = [
  {
    label: "All users who don't have one",
    value: 'FOR_EVERYONE',
  },
  {
    label: 'Only new users',
    value: 'FOR_NEW_CLIENTS',
  },
  {
    label: 'No need to collect credit card information',
    value: 'NO_THANKS',
  },
];

export default function ClientBilling({
  isMytime,
  details,
  onChange,
  disabled,
  auth,
  softwares,
  preferences,
}) {
  const bzsW =
    auth.booking_software && auth.booking_software !== 'undefined'
      ? auth.booking_software
      : softwares.selectedSoftware;

  const isTruelark = softwares?.is_truelark;
  const onNoCCChange = (item) => {
    onChange({
      target: {
        name: 'cc_not_on_file_action',
        value: item.value,
      },
    });
  };

  const onCollectPaymentInfoChange = (item) => {
    onChange({
      target: {
        name: 'collect_credit_card',
        value: item.value,
      },
    });
  };

  const onCollectCouponNumberChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'collect_coupon_number',
        checked: !details.collect_coupon_number,
      },
    });
  };

  const onCCForCouponsChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'cc_for_coupons',
        checked: !details.cc_for_coupons,
      },
    });
  };

  const onExpiredVoucherAcceptChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'is_expired_voucher_accepted',
        checked: !details.is_expired_voucher_accepted,
      },
    });
  };

  const onVoucherCombineChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'can_voucher_be_combined_with_offer',
        checked: !details.can_voucher_be_combined_with_offer,
      },
    });
  };
  const { schema } = preferences;
  const { appointment_preferences } = schema;
  return (
    <div className="bookings">
      {isTruelark &&
        bzsW !== 'PHOREST' &&
        bzsW !== 'ACUITY' &&
        bzsW !== 'RESTORE' &&
        bzsW !== 'MEEVO' &&
        appointment_preferences.properties?.collect_credit_card && (
          <div className="bookings__row">
            <p className="bookings__row__label">
              {appointment_preferences.properties?.collect_credit_card
                ?.description ||
                'For whom would you like TrueLark to collect credit card information?'}
            </p>
            <div className="bookings__row__input">
              <Select
                name="collect_credit_card"
                value={collectCCOptions.filter(
                  (option) => option.value === details.collect_credit_card,
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={collectCCOptions}
                onChange={onCollectPaymentInfoChange}
                disabled={disabled}
              />
            </div>
          </div>
      )}

      {isTruelark &&
        bzsW !== 'ACUITY' &&
        bzsW !== 'RESTORE' &&
        details.collect_credit_card &&
        details.collect_credit_card !== 'NO_THANKS' &&
        !details.collect_cc_before_booking &&
        appointment_preferences.properties?.cc_not_on_file_action ? (
          <>
            <div className="bookings__row">
            <p className="bookings__row__label">
              {appointment_preferences.properties?.cc_not_on_file_action
                ?.description ||
                `In case credit card details are not provided, what would you like
              TrueLark to do?`}
              <br />
              <span className="hint-text">
                Note: We will send a reminder to the guest to encourage them to
                update their credit card details
              </span>
            </p>
            <div className="bookings__row__input">
              <Select
                name="cc_not_on_file_action"
                value={noCCOptions.filter(
                  (option) => option.value === details.cc_not_on_file_action,
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={noCCOptions}
                onChange={onNoCCChange}
                disabled={disabled}
              />
            </div>
          </div>
          </>
        ) : undefined}
      {appointment_preferences.properties?.discount_coupons && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            How would you like us to respond if the guest asks the following?
            <br />
            {appointment_preferences.properties?.discount_coupons
              ?.description || 'What discount coupons do you accept?'}
          </p>
          <div className="bookings__row__input">
            <textarea
              rows="3"
              placeholder="e.g. Groupon, etc"
              name="discount_coupons"
              value={details.discount_coupons}
              onChange={onChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {details.discount_coupons &&
        appointment_preferences.properties?.collect_coupon_number ? (
            <div className="special-row">
              <p className="special-row__label">
                {appointment_preferences.properties?.collect_coupon_number
                  ?.description ||
                  `In such cases, is it necessary to collect voucher number(s) before
                bookings?`}
              </p>
              <div className="special-row__input">
              <ToggleSwitch
                checked={!!details.collect_coupon_number}
                name="collect_coupon_number"
                onChange={onCollectCouponNumberChange}
                disabled={disabled}
              />
            </div>
          </div>
        ) : undefined}

      {details.discount_coupons &&
        appointment_preferences.properties?.is_expired_voucher_accepted ? (
            <div className="special-row">
            <p className="special-row__label">
              {appointment_preferences.properties?.is_expired_voucher_accepted
                ?.description || 'Do you honor expired discount coupons?'}
            </p>
            <div className="special-row__input">
              <ToggleSwitch
                checked={!!details.is_expired_voucher_accepted}
                name="is_expired_voucher_accepted"
                onChange={onExpiredVoucherAcceptChange}
                disabled={disabled}
              />
            </div>
          </div>
        ) : undefined}

      {details.discount_coupons &&
        appointment_preferences.properties?.can_voucher_be_combined_with_offer ? (
            <div className="special-row">
            <p className="special-row__label">
              How would you like us to respond if the guest asks the following?
              <br />
              {appointment_preferences.properties
                ?.can_voucher_be_combined_with_offer?.description ||
                'Can I combine discount coupons with other offers?'}
            </p>
            <div className="special-row__input">
              <ToggleSwitch
                checked={!!details.can_voucher_be_combined_with_offer}
                name="can_voucher_be_combined_with_offer"
                onChange={onVoucherCombineChange}
                disabled={disabled}
              />
            </div>
          </div>
        ) : undefined}
      {isTruelark &&
        bzsW !== 'PHOREST' &&
        bzsW !== 'ACUITY' &&
        bzsW !== 'RESTORE' &&
        bzsW !== 'MEEVO' &&
        appointment_preferences.properties?.cc_for_coupons && (
          <div className="special-row">
            <p className="special-row__label">
              {appointment_preferences.properties?.cc_for_coupons
                ?.description ||
                `If the guest is using any of these payment methods, is it necessary
            to collect credit card information?`}
            </p>
            <div className="special-row__input">
              <ToggleSwitch
                checked={!!details.cc_for_coupons}
                name="cc_for_coupons"
                onChange={onCCForCouponsChange}
                disabled={disabled}
              />
            </div>
          </div>
      )}
      {isTruelark &&
        appointment_preferences.properties?.accepted_insurance_policies && (
          <div className="bookings__row">
            <p className="bookings__row__label">
              {appointment_preferences.properties?.accepted_insurance_policies
                ?.description || 'What insurance policies do you accept?'}
            </p>
            <div className="bookings__row__input">
              <textarea
                rows="3"
                placeholder=""
                name="accepted_insurance_policies"
                value={details.accepted_insurance_policies}
                onChange={onChange}
                disabled={disabled}
              />
            </div>
          </div>
      )}
    </div>
  );
}

ClientBilling.defaultProps = {
  onChange: () => { },
  details: {},
  disabled: false,
};

ClientBilling.propTypes = {
  onChange: PropTypes.func,
  details: PropTypes.shape(),
  disabled: PropTypes.bool,
};
